// Approximate service area boundaries for each regional hub.
// Polygon coordinates trace the outer suburbs we service in each region.
// Centers and zoom are tuned so the polygon + all suburb pins fit nicely.

export const SERVICE_AREAS_MAP = {
  ipswich: {
    name: "Ipswich Region",
    center: { lat: -27.6260, lng: 152.8200 },
    zoom: 11,
    polygon: [
      { lat: -27.5450, lng: 152.6700 }, // NW (Brassall)
      { lat: -27.5500, lng: 152.7700 }, // N (North Ipswich)
      { lat: -27.5650, lng: 152.9150 }, // NE (Goodna)
      { lat: -27.6500, lng: 152.9300 }, // E (Springfield Lakes)
      { lat: -27.7100, lng: 152.8900 }, // SE (Ripley)
      { lat: -27.7100, lng: 152.7600 }, // S (Deebing Heights)
      { lat: -27.6800, lng: 152.6700 }, // SW
      { lat: -27.6000, lng: 152.6500 }, // W
    ],
    suburbs: [
      { name: "Ipswich CBD", position: { lat: -27.6171, lng: 152.7610 } },
      { name: "Brassall", position: { lat: -27.5950, lng: 152.7460 } },
      { name: "Booval", position: { lat: -27.6090, lng: 152.7920 } },
      { name: "Bundamba", position: { lat: -27.6080, lng: 152.8050 } },
      { name: "Redbank Plains", position: { lat: -27.6450, lng: 152.8830 } },
      { name: "Goodna", position: { lat: -27.6100, lng: 152.9100 } },
      { name: "Springfield", position: { lat: -27.6620, lng: 152.9170 } },
      { name: "Springfield Lakes", position: { lat: -27.6800, lng: 152.9050 } },
      { name: "Ripley", position: { lat: -27.6900, lng: 152.8470 } },
      { name: "Deebing Heights", position: { lat: -27.6580, lng: 152.7470 } },
    ],
  },

  "lockyer-valley": {
    name: "Lockyer Valley",
    center: { lat: -27.5400, lng: 152.2700 },
    zoom: 10,
    polygon: [
      { lat: -27.4000, lng: 152.1300 }, // NW (Murphys Creek)
      { lat: -27.4200, lng: 152.4600 }, // NE (Withcott)
      { lat: -27.5500, lng: 152.5000 }, // E (Lockrose / Hatton Vale)
      { lat: -27.6300, lng: 152.4200 }, // SE (Laidley)
      { lat: -27.6500, lng: 152.2500 }, // S (Forest Hill)
      { lat: -27.6300, lng: 152.0500 }, // SW (Helidon)
      { lat: -27.5000, lng: 152.0500 }, // W (Grantham)
    ],
    suburbs: [
      { name: "Gatton", position: { lat: -27.5560, lng: 152.2740 } },
      { name: "Laidley", position: { lat: -27.6320, lng: 152.3940 } },
      { name: "Plainland", position: { lat: -27.5740, lng: 152.4180 } },
      { name: "Withcott", position: { lat: -27.5500, lng: 151.9990 } },
      { name: "Helidon", position: { lat: -27.5510, lng: 152.1290 } },
      { name: "Forest Hill", position: { lat: -27.5980, lng: 152.3500 } },
      { name: "Grantham", position: { lat: -27.5680, lng: 152.1980 } },
      { name: "Hatton Vale", position: { lat: -27.5760, lng: 152.4650 } },
      { name: "Murphys Creek", position: { lat: -27.4670, lng: 152.0260 } },
    ],
  },

  "brisbane-south": {
    name: "Brisbane South",
    center: { lat: -27.5550, lng: 153.1000 },
    zoom: 11,
    polygon: [
      { lat: -27.4900, lng: 153.0500 }, // NW (Greenslopes)
      { lat: -27.4900, lng: 153.1900 }, // NE (Camp Hill)
      { lat: -27.5350, lng: 153.2400 }, // E (Capalaba)
      { lat: -27.6100, lng: 153.2700 }, // SE (Mt Cotton)
      { lat: -27.6300, lng: 153.1500 }, // S (Rochedale)
      { lat: -27.6000, lng: 153.0700 }, // SW (Sunnybank)
      { lat: -27.5300, lng: 153.0500 }, // W (Holland Park)
    ],
    suburbs: [
      { name: "Mt Gravatt", position: { lat: -27.5440, lng: 153.0810 } },
      { name: "Sunnybank", position: { lat: -27.5750, lng: 153.0590 } },
      { name: "Carindale", position: { lat: -27.5070, lng: 153.0980 } },
      { name: "Wishart", position: { lat: -27.5660, lng: 153.0980 } },
      { name: "Upper Mt Gravatt", position: { lat: -27.5630, lng: 153.0860 } },
      { name: "Eight Mile Plains", position: { lat: -27.5870, lng: 153.0920 } },
      { name: "Rochedale", position: { lat: -27.6050, lng: 153.1310 } },
      { name: "Holland Park", position: { lat: -27.5230, lng: 153.0710 } },
      { name: "Coorparoo", position: { lat: -27.4970, lng: 153.0640 } },
      { name: "Capalaba", position: { lat: -27.5240, lng: 153.1990 } },
    ],
  },

  "brisbane-west": {
    name: "Brisbane West",
    center: { lat: -27.5200, lng: 152.9500 },
    zoom: 11,
    polygon: [
      { lat: -27.4500, lng: 152.8700 }, // NW (Brookfield)
      { lat: -27.4750, lng: 153.0100 }, // NE (Toowong area)
      { lat: -27.5200, lng: 153.0250 }, // E (Sherwood)
      { lat: -27.5800, lng: 153.0100 }, // SE (Oxley)
      { lat: -27.6000, lng: 152.9300 }, // S (Darra)
      { lat: -27.5600, lng: 152.8500 }, // SW (Mt Ommaney)
      { lat: -27.4900, lng: 152.8400 }, // W (Kenmore Hills)
    ],
    suburbs: [
      { name: "Indooroopilly", position: { lat: -27.5040, lng: 152.9740 } },
      { name: "Kenmore", position: { lat: -27.5060, lng: 152.9380 } },
      { name: "Chapel Hill", position: { lat: -27.5050, lng: 152.9520 } },
      { name: "Jindalee", position: { lat: -27.5350, lng: 152.9430 } },
      { name: "Mt Ommaney", position: { lat: -27.5470, lng: 152.9220 } },
      { name: "Sherwood", position: { lat: -27.5260, lng: 152.9810 } },
      { name: "Graceville", position: { lat: -27.5210, lng: 152.9800 } },
      { name: "Corinda", position: { lat: -27.5400, lng: 152.9760 } },
      { name: "Oxley", position: { lat: -27.5570, lng: 152.9810 } },
      { name: "Brookfield", position: { lat: -27.4940, lng: 152.9050 } },
    ],
  },

  logan: {
    name: "Logan Corridor",
    center: { lat: -27.7000, lng: 153.1300 },
    zoom: 11,
    polygon: [
      { lat: -27.6200, lng: 152.9700 }, // NW (Browns Plains)
      { lat: -27.6300, lng: 153.1500 }, // N (Springwood)
      { lat: -27.6700, lng: 153.2300 }, // NE (Daisy Hill)
      { lat: -27.7400, lng: 153.2400 }, // E (Loganholme)
      { lat: -27.7900, lng: 153.2400 }, // SE (Beenleigh / Eagleby)
      { lat: -27.8000, lng: 153.0500 }, // S
      { lat: -27.7300, lng: 152.9700 }, // SW
      { lat: -27.6600, lng: 152.9700 }, // W (Marsden)
    ],
    suburbs: [
      { name: "Logan Central", position: { lat: -27.6420, lng: 153.1080 } },
      { name: "Woodridge", position: { lat: -27.6360, lng: 153.1100 } },
      { name: "Browns Plains", position: { lat: -27.6620, lng: 153.0440 } },
      { name: "Marsden", position: { lat: -27.6780, lng: 153.0510 } },
      { name: "Crestmead", position: { lat: -27.6920, lng: 153.0610 } },
      { name: "Beenleigh", position: { lat: -27.7110, lng: 153.2030 } },
      { name: "Eagleby", position: { lat: -27.7220, lng: 153.2240 } },
      { name: "Waterford", position: { lat: -27.7050, lng: 153.1300 } },
      { name: "Springwood", position: { lat: -27.6130, lng: 153.1340 } },
      { name: "Loganholme", position: { lat: -27.6900, lng: 153.1880 } },
    ],
  },
};
